import { Menu, UserLevel } from '@/types';
import { initiateAnalysisOpen, completedAnalysesOpen } from './state';

export const menu: Menu = {
  text: 'Analysis',
  menu_width: 220,
  menu: [
    {
      text: 'Initiate Grimace Analysis',
      click: () => { initiateAnalysisOpen.value = true; },
    },
    {
      text: 'Completed Analyses',
      click: () => { completedAnalysesOpen.value = true; },
    },
  ],
  disallowed: [UserLevel.Annotator],
};
